export const getDesignations = '/designations';
